import maplibre from 'maplibre-gl';

import DetectLanguage from './DetectLanguage.js';
// import PoiLayer from './PoiLayer.js';

/**
 * Default options for maplibre-gl Map.
 */
export default class DefaultMap extends maplibre.Map {
    /**
     * Instantiate map with the given options. Supports the options from
     * maplibre.Map and some additional custom options.
     * @param {Object} options - Map options.
     */
    constructor(options) {
        const customOptions = {
        };
        for (let key of Object.keys(customOptions)) {
            if (options[key] !== undefined) {
                customOptions[key] = options[key];
                delete options[key];
            }
        }
        super({
            style: '/api/map/style/standard',
            dragRotate: false,
            ...options
        });
        this.touchZoomRotate.disableRotation();
        this.addControl(new maplibre.NavigationControl({ showCompass: false }));
        this.addControl(new maplibre.FullscreenControl());
        this.addControl(new DetectLanguage());

        // Collapse attribution control after 5 seconds. OSM license specifies
        // that "You may use a mechanism to fade/collapse the attribution under
        // certain conditions: [...] automatically after five seconds. This
        // also applies to splash screens or pop-ups." By default the
        // attribution control will collapse when you interact with the map but
        // on the small maps we use mainly for presentation the attribution
        // takes up a big chunk of the available space, so additionally
        // collapse it after a short delay.
        setTimeout(() => {
            const container = this.getContainer().querySelector('.maplibregl-ctrl-attrib');
            if (container && container.classList.contains('maplibregl-compact-show')) {
                container.classList.remove('maplibregl-compact-show', 'mapboxgl-compact-show');
                container.removeAttribute('open');
            }
        }, 5000);

        // new PoiLayer().addTo(this);
    }
}

export function isWebGlError(error) {
    return /Failed to initialize WebGL/.test(error.message);
}

export function handleWebGlError(error, id) {
    if (isWebGlError(error)) {
        const msg = document.createElement('div');
        msg.textContent = 'WebGL not supported';
        msg.style.textAlign = 'center';
        msg.style.background = '#ccc';
        document.getElementById(id).appendChild(msg);
    } else {
        throw error;
    }
}
